import BaseAPIService from '@/services/baseAPIService'

export default class DespatchAPIService extends BaseAPIService {
  constructor(httpClient, reportingHttpClient) {
    super(httpClient, reportingHttpClient)
  }

}
